// Simple global object used to store the culture info (name). This is used by the resource classes.
// Todo: To share this across projects move this into an npm package (and resjson-to-typescript.* into a package that requires the "Culture" package).
export class Culture {
    private static _lang: string;
    private static _cutlureCode: string;

    // Set culture name: ie "en".
    static set Lang(lang: string) {
        this._lang = lang;
    }

    // Get culture name: ie "en".
    static get Lang(): string {
        return this._lang;
    }

    // Set culture name: ie "en".
    static set CultureCode(cultureCode: string) {
        this._cutlureCode = cultureCode;
    }

    // Get culture name: ie "en".
    static get CultureCode(): string {
        return this._cutlureCode;
    }
}



// WEBPACK FOOTER //
// ./Client/Resources/Culture.ts